
  const sentryInfo = {
  "environment": "edge",
  "release": "edge@1793807189554"
};
  export default sentryInfo;
